import { ControllerVersion } from '@bymason/controller-api-hooks';
import { useContext } from 'react';
import GlobalStateContext, { UpdateControllerVersion } from './context';

export { ControllerVersion } from '@bymason/controller-api-hooks';

/**
 * Hook to fetch latestt group and device counts in this account.
 * @returns [devices count, groups count, fetch latest counts]
 */
export function useAccountMetadata() {
  const { devicesCount, groupsCount, projectsCount, fetchCounts } = useContext(GlobalStateContext);

  return { devicesCount, groupsCount, projectsCount, fetchLatestCounts: fetchCounts } as {
    devicesCount: number | null;
    groupsCount: number | null;
    projectsCount: number | null;
    fetchLatestCounts: () => void;
  };
}

/**
 * Hook to get and update the Controller version selection.
 * @returns [selected version, update selection]
 */
export function useSelectedControllerPref() {
  const { selectedControllerVersion, updateSelectedControllerVersion } = useContext(GlobalStateContext);

  return [selectedControllerVersion, updateSelectedControllerVersion] as [
    ControllerVersion | null | undefined,
    UpdateControllerVersion
  ];
}

/**
 * Hook to check whether the new controller tooltip should be shown.
 * @returns [showNewControllerTooltip, setShowNewControllerTooltip]
 */
export function useShowNewControllerTooltip() {
  const { showNewControllerTooltip, setShowNewControllerTooltip } = useContext(GlobalStateContext);

  return [showNewControllerTooltip, setShowNewControllerTooltip] as [
    boolean,
    (showNewControllerTooltip: boolean) => void
  ];
}

export function useCheckFeatureFlag(name: string): [boolean, string] {
  const { featureFlags } = useContext(GlobalStateContext);
  const featureFlag = featureFlags.find((flag) => flag.name === name);
  return [!!featureFlag, featureFlag?.description] as [boolean, string];
}
